import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { Field } from 'src/app/tools/models/dtos/field';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PackingOrder } from '../../models/entities/packing-order';
import { PackingOrderProduct } from '../../models/entities/packing-order-product';
import { PackingOrderService } from '../../services/packing-order.service';
import { MatDialog } from '@angular/material/dialog';
import { BatchLovComponent } from 'src/app/assabil-admin/components/master-data/product/batch-lov/batch-lov.component';

@Component({
    selector: 'packing-order-widget',
    templateUrl: './packing-order-widget.component.html',
    styleUrls: ['./packing-order-widget.component.scss']
})

export class PackingOrderWidgetComponent extends BaseWidget {

@Input() packListFields          : Field[] = [];
@Input() batchListFields          : Field[] = [];


packingOrder            : PackingOrder = new PackingOrder();

//----------------------------------------------------------------------------------------------------------------------------------------------------
 constructor(
     protected toastr               : ToastrService,
     protected leanUtilsService     : LeanUtilsService,
     protected dialog                : MatDialog,
     protected packingOrderService  : PackingOrderService) {
     super(toastr, leanUtilsService);

     this.entityName = "packingOrder";
 }
//---------------------------------------------------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------------------------------------------------------------------
setEntity(packingOrder: PackingOrder) {
     this.packingOrder  = { ...packingOrder };
     this.packingOrder.packingOrderSteps = [];
     if (packingOrder.packingOrderSteps) {
       for (let packingOrderStep of packingOrder.packingOrderSteps) {
         this.packingOrder.packingOrderSteps.push({ ...packingOrderStep });
       }
     }
   }
//---------------------------------------------------------------------------------------------------------------------------------------------------

 
//---------------------------------------------------------------------------------------------------------------------------------------------------
 getEntity(){
   return this.packingOrder;
 }
//---------------------------------------------------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------------------------------------------------------------------
saveRow(): Promise<PackingOrder> {
  if (! this.packingOrder.packingOrderCode) {
    this.showError("Prière de saisir le code du l'ordre de conditionnement ");
    return;
  }
  if (! this.packingOrder.theDate) {
    this.showError("Prière de saisir la date du l'ordre de conditionnement ");
    return;
  }
  if (! this.packingOrder.quantity) {
    this.showError("Prière de saisir la quantité de palettes du l'ordre de conditionnement ");
    return;
  }
  if (! this.packingOrder.expiringDate) {
    this.showError("Prière de saisir la date d'expiration des palettes du l'ordre de conditionnement ");
    return;
  }

  for (let packingOrderStep of this.packingOrder.packingOrderSteps){
    if ( (! packingOrderStep.packingMachine) && (packingOrderStep.packingProcessStep.packingMachines)){
      this.showError("Prière de précisier la machine de la phase n° : " + packingOrderStep.rank);
      return;
    }
  }

 return this.packingOrderService.packingOrderSave(this.packingOrder);
}
//---------------------------------------------------------------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------------------------------------------------------------------
  getBadges() : string {
    let res = "<div class='multi-labels'>";
    if (this.packingOrder.progressLevel == 0)   res += "<div class='label-orange'> " + "Nouveau" + " </div>";
    if (this.packingOrder.progressLevel == 10)  res += "<div class='label-green'> "  + "En cours" + " </div>";
    if (this.packingOrder.progressLevel == 100) res += "<div class='label-gray'> "   + "Clos" + " </div>";
    res +=  "<div class='label-red'> " + this.packingOrder.product.codeName + " </div>";
    res += "</div>"
    return  res;
  }
//---------------------------------------------------------------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------------------------------------------------------------------
  getQuantityRate(packingOrderProduct : PackingOrderProduct) : string{
    let rate = packingOrderProduct.assignedQuantity  + " / " + (packingOrderProduct.quantity *  this.packingOrder.quantity) ;
    return rate;
  }
//---------------------------------------------------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------------------------------------------------------------------
  addBatches() {
    this.packingOrderService.packingOrderPotentialBatchsGet(this.packingOrder).then(batchs => {

      let dialogRef = this.dialog.open(BatchLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, batchs : batchs }});
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          if (result.selectedBatchs) {
            this.packingOrderService.linkBatchsToPackingOrder(this.packingOrder, result.selectedBatchs).then(packingOrder => {
                this.packingOrder = packingOrder;
            })
          }
        }
      });
    });
  }
//-----------------------------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------------------------------------------------------------------
  packingOrderStart(){
    this.packingOrderService.packingOrderStart(this.packingOrder).then(packingOrder => {
      this.packingOrder = packingOrder;
    })
  }
  packingOrderClose(){
    this.packingOrderService.packingOrderClose(this.packingOrder).then(packingOrder => {
      this.packingOrder = packingOrder;
    })
  }
//---------------------------------------------------------------------------------------------------------------------------------------------------

}
